const ClientStockRateComponent = () => import('@/views/business/ClientStockRate/ClientStockRateView')

export default [
    {
        path:'/ClientStockRateIndex',
        name:'ClientStockRateComponent',
        component:ClientStockRateComponent
    }
]